import { http } from "./axios";

export const getPublicPortfolios = async () => {
  const response = await http.get("/portfolio");

  return response.data;
};

export const getAdminPortfolios = async () => {
  const response = await http.get("/admin/portfolio");

  return response.data;
};

export const createPortfolio = async (data) => {
  const response = await http.post(
    "/admin/portfolio",
    data
  );

  return response.data;
};

export const updatePortfolio = async (id, data) => {
  const response = await http.put(
    `/admin/portfolio/${id}`,
    data
  );

  return response.data;
};

export const deletePortfolio = async (id) => {
  const response = await http.delete(
    `/admin/portfolio/${id}`
  );

  return response.data;
};